export enum EventListType {
	FUTURE = 'FUTURE',
	CANCELED = 'CANCELED',
}
